<mat-divider [vertical]="vertical"
  [attr.role]="null"
  aria-hidden="true">
</mat-divider>
